import { mapState, mapGetters, mapActions } from 'vuex'

export const notificationComputed = {
  ...mapState('notification', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('notification', [
    'getNotificationList',
    'getNotificationPaginate',
    'getQuotes',
    'getNotificationDetail',
    'getPreviewCount',
    'getStatusAddRequest',
    'getDeleteStatusRequest',
    'getDeliverStatusRequest',
    'getAcceptRevokeStatusRequest',
    'getRejectRevokeStatusRequest',
  ]),
}

export const notificationMethods = mapActions('notification', [
  'fetchingNotificationList',
  'fetchingQuotes',
  'fetchingNotificationById',
  'fetchingPreviewCount',
  'registerNotification',
  'resetAfterRegister',
  'editNotification',
  'resetDetails',
  'deleteNotification',
  'deliverEndNotification',
  'acceptRevoke',
  'rejectRevoke',
  'resetAfterStop',
  'resetAfterAccept',
  'resetAfterReject',
  'requestRevoke',
])
